<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
		<mtiporesolucion-modals
			:modelName="modelName"
		></mtiporesolucion-modals>
	</div>
</template>

<script>
import mtiporesolucionActions from './MtiporesolucionActions';
import mtiporesolucionModals from './MtiporesolucionModals.vue';

export default {
	name: 'mtiporesolucion-grid',
	components: {
		'mtiporesolucion-modals': mtiporesolucionModals
	},
	data() {
		return {
			modelName: 'mtiporesolucion',
			actions: mtiporesolucionActions.gridactions,
			modelColumnDefs: {
			}
		}
	}
}
</script>
